import { create } from '@storybook/theming/create';

export default create({
  base: 'light',
  brandTitle: 'Mayo UI',
  brandUrl:
    'https://mayohr.visualstudio.com/TUBE-FrontendComponent/_git/mayo-ui',
});
